// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".role-wrapper[data-v-1b075edd]{width:20%;text-align:center}.tag[data-v-1b075edd]{width:100%;padding:3px 0;border-radius:5px}.guest-tag[data-v-1b075edd]{color:#3566bc;background-color:#d4dff1}.buddy-tag[data-v-1b075edd]{color:#f0af2c;background-color:#fdf4e2}.owner-tag[data-v-1b075edd]{background-color:#f5f6fa}", ""]);
// Exports
module.exports = exports;
